module.exports = require("core-js/modules/es6.string.iterator");